<template>
    <div id="services">
        <div class="container-fluid">
            <div class="row main-content">
                <div class="col-md-12">
                    <div class="services-text-main-container">
                        <div class="small-title pull-left">
                            <h4 v-html="state.title"></h4>
                            <hr>
                        </div>
    
                        <div class="services-main-container " data-aos="fade-right">
    
                            <h1>{{state.subTitle}}</h1>
                            <p v-html="state.pTextTop"></p>
                        </div>
                        <div class="services-icon-text-container">
                            <div class="left-icon-text">
                                <div class="service-icontext-container">
                                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_logistica_int.png" width="100px">
                                    <h4 class="service-h4">{{state.serviceText1}}</h4>
                                </div>
                                <div class="service-icontext-container">
                                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_fronterizo.png" width="100px">
                                    <h4 class="service-h4">{{state.serviceText2}}</h4>
                                </div>
                                <div class="service-icontext-container">
                                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_operador.png" width="100px">
                                    <h4 class="service-h4" v-html="state.serviceText3"></h4>
                                </div>
                                <div class="service-icontext-container">
                                    <img class="img-left-align" data-aos="zoom-in" src="../../assets/icons/icon_urgentes.png" width="100px">
                                    <h4 class="service-h4">{{state.serviceText4}}</h4>
                                </div>
                            </div>
                            <div class="right-icon-text">
                                <div class="service-icontext-container">
                                    <img class="img-right-align" data-aos="zoom-in" src="../../assets/icons/icon_transporte.png" width="100px">
                                    <h4 class="service-h4">{{state.serviceText5}}</h4>
                                </div>
                                <div class="service-icontext-container">
                                    <img class="img-right-align" data-aos="zoom-in" src="../../assets/icons/icon_entrega.png" width="100px">
                                    <h4 class="service-h4" v-html="state.serviceText6"></h4>
                                </div>
                                <div class="service-icontext-container">
                                    <img class="img-right-align" data-aos="zoom-in" src="../../assets/icons/icon_direccion.png" width="100px">
                                    <h4 class="service-h4">{{state.serviceText7}}</h4>
                                </div>
                                <div class="service-icontext-container">
                                    <img class="img-right-align" data-aos="zoom-in" src="../../assets/icons/icon_almacen.png" width="100px">
                                    <h4 class="service-h4">{{state.serviceText8}}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 pull-right blue-container-cert" style="padding-left:0px; padding-right:0px;" data-aos="fade-in">
                        <div class="small-title-bluediv pull-right">
                            <hr>
                            <h4 v-html="state.title"></h4>
                        </div>
                        <div class="contenedor-cert">
    
                            <h2 style="margin-top:100px;color:white;">{{state.certTitle}}</h2>
                            <img src="./../../assets/logos/logo_certificacion_canacar.png">
                            <hr>
                            <img src="./../../assets/logos/logo_certificacion_oea.png">
                            <hr>
                            <img src="./../../assets/logos/logo_certificacion_ctpat.png">
                        </div>
                    </div>
                    <div class="col-md-4 pull-left" style="padding:0px;">
                        <img class="white-truck" src="./../../assets/imgs/servicios_foto1.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 footer-container" style="padding:20px;">
            <router-link to="/contacto" tag="a">
                <h3>CONTÁCTANOS</h3>
            </router-link>
            <hr style="border-top:1px solid white;">
            <p>Copy right @2017 - All Rights Reserved</p>
        </div>
    </div>
</template>

<script>
var $ = require('jquery')
export default {
    data() {
        return {
            inventario: {
                primero: {
                    img: 'home_cajaseca',
                    texto: '205 cajas secas 53”'
                },
                segundo: {
                    img: 'home_plataforma',
                    texto: '15 plataforma 48”'
                },
                tercero: {
                    img: 'home_tanque',
                    texto: '90 tanques'
                },
                cuarto: {
                    img: 'home_foodgrade',
                    texto: '5 tanques food grade'
                },
                quinto: {
                    img: 'home_tractocamion',
                    texto: '100 Tractocamiones'
                }
            }
            // 205 cajas secas 53”
            // 15 plataforma 48”
            // 90 tanques
            // 5 tanques food grade 
            // 100 Tractocamiones 

        }
    },
    methods: {
        invImgUrl(img) {
            return require('../../assets/imgs/' + img + '.png')
        }
    },
    components: {
    },
    computed: {
        state(){
            return this.$store.state.activeList.servicesPage
        }
    },
    mounted() {
        $('.eq-items').first().removeClass('hidden')
        var i = 0
        setInterval(() => {
            $('.eq-items').each((index, val) => {
                if (!$(val).hasClass('hidden') && i !== 1) {
                    $(val).addClass('hidden animated fadeIn')
                    $(val).next().removeClass('hidden').addClass('animated fadeIn')
                    if (index === 4) {
                        $('#0').removeClass('hidden')
                        $('#0').addClass('animated fadeIn')
                    }
                    i++
                }
            })
            i = 0
        }, 5000)
    }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

.footer-container {
    background-color: $gris;
    color: white;
}

a {
    color: white;
}

.main-content {
    display: block;
    color: $gris;
    height: 100%;
}

.services-text-main-container {
    padding: 150px;
}

.services-main-container {
    max-width: 1400px;
    margin: auto;
    margin-top: 100px;
    text-align: left;
}

.services-main-container p {
    font-size: 15pt;
}



.truck-img-contqainer {
    text-align: left;
}

.img-container {
    position: absolute;
    color: white;
    right: 0px;
    height: 100%;
    min-height: 100%;
    background-image: url(../../assets/imgs/home_foto2.png);
}

.services-icon-text-container {
    width: 100%;
    text-align: center;
    padding-left: 15%;
    padding-right: 15%;
    padding-top: 5%;
}

.service-icontext-container {
    margin: auto;
    margin-bottom: 50px;
    text-align: left;
}

.service-h4 {
    font-size: 12pt;
    margin-left: 40px;
    margin-top: 40px;
}

h4 {
    color: $gris;
    display: inline-block;
}


p {
    text-align: center;
    margin-top: 40px;
}

hr {
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 20%;
    border-top: 2px solid $rojo;
    margin: 1em 1em;
    padding: 0;
}

h1 {
    color: $azul;
    font-size: 80pt;
}

.text-container {
    text-align: left;
    margin-top: 5%;
}

.small-title {
    width: 100%;
    text-align: left;
    padding: 25px;
    vertical-align: middle;
    margin-top: 100px;
}

.small-title-bluediv {
    width: 100%;
    text-align: right;
    padding: 25px;
    vertical-align: middle;
    margin-top: 100px;
}

.small-title-bluediv h4 {
    color: white!important;
}

.small-title-bluediv hr {
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 20%;
    border-top: 2px solid $rojo;
    margin: 1em 1em;
    padding: 0;
}

.cornered {
    float: right;
    width: 0;
    height: 0;
    border-top: 900px solid $azul;
    border-left: 100px solid transparent;
    border-right: 1100px solid $azul;
}



.certificaciones-cont {
    text-align: center;
}

.certificaciones-cont hr {
    display: block;
}

.certificaciones-cont img {
    display: block;
}

.certificaciones-cont h1 {
    display: block;
}

.whitetruck-img {
    text-align: left;
    width: 68%;
    left: 0px;
    display: inline-block;
    position: absolute;
    margin-top: 7%;
}

.contenedor-cert {
    background-color: $azul;
    width: 100%;
    padding: 50px;
}

.contenedor-cert img {
    display: block;
    margin: auto;
    margin-top: 80px;
}

.contenedor-cert hr {
    display: block;
    margin: auto;
    margin-top: 80px;
}

.white-truck {
    margin-top: 400px;
    width: 130%;
}

.left-icon-text {
    float: left;
    margin: auto;
    text-align: center;
}

.right-icon-text {
    float: right;
    margin: auto;
}

@media screen and (max-width:1361px) {

    .equip-div img {
        float: right;
        width: 40%;
        padding-top: 30px;
        padding-bottom: 30px;
        display: inline-block;
    }

    .equip-div h1 {
        color: white;
        padding: 85px 0px;
        font-size: 30pt;
        display: inline-block;
    }
    .equip-div h1>a {
        color: white;
        padding: 10px 20px;
        background-color: $rojo;
        font-size: 15pt;
        width: 150px;
        height: 100px;
        -webkit-transform: skew(20deg);
        -moz-transform: skew(20deg);
        -o-transform: skew(20deg);
    }
    .equip-div {
        position: relative;
        top: 0px;
        right: 0;
        background-color: $azul;
    }

    .cornered {
        width: 100%;
        box-sizing: none;
        border-bottom: 0em solid $azul;
        border-left: 0em solid transparent;
    }

    .contenedor-equipo {
        background-color: $azul;
    }
}


@media screen and (max-width:1210px) {
    .service-icontext-container {
        text-align: center;
    }

    .left-icon-text {
        float: none;
        margin: auto;
        text-align: center;
    }

    .img-left-align {
        display: block;
        margin: auto;
    }

    .left-icon-text {
        float: none;
        margin: auto;
        text-align: center;
    }

    .right-icon-text {
        float: none;
        margin: auto;
        text-align: center;
    }

    .right-icon-text img {
        display: block;
        margin: auto;
    }

    .services-text-main-container {
        padding: 20px;
        text-align: left;
    }

    .services-icon-text-container {
        width: 100%;
        text-align: center;
        padding-left: 0%;
        padding-right: 0%;
        padding-top: 5%;
    }

    .services-icon-text-container img {
        width: 70px;
    }

    .services-icon-text-container h4 {
        font-size: 18pt;
    }

    h1 {
        font-size: 30pt;
    }

    .service-h4 {
        margin-left: 0px;
    }

    .equip-div img {
        width: 90%;
    }

    h4 {
        font-size: 16px;
    }

    .services-main-container p {
        text-align: left;
    }
}


@media screen and (max-width:992px) {
    .white-truck {
        display: none;
    }

    .blue-container-cert {
        width: 100%;
    }
}
</style>





// WEBPACK FOOTER //
// ServiciosmainPage.vue?4044e8d6